var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center",class:{
    'strategio-hidden-item': _vm.processGroup.isEnabled === 0
  },style:([
    {'height': '282px'},
    {'width': '313px'},
    {'margin': '20px'},
    {'overflow': 'hidden'},
    {'background': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'},
    {'border-radius': '10px'}
  ]),attrs:{"outlined":""},on:{"click":_vm.enterProcessGroup}},[_c('div',[_c('v-icon',{staticStyle:{"font-size":"52px"},attrs:{"color":'black'}},[_vm._v("ico-icon-config")])],1),_vm._v(" "),_c('div',{staticClass:"strategio-autoservicio-card-title",staticStyle:{"margin-top":"15px"}},[_vm._v("\n    "+_vm._s(_vm.processGroup.groupName)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418005f7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/groups/autoservicio-group.vue
// module id = null
// module chunks = 